import { useCallback } from 'react';
const ogv = require('ogv');

//For local audio reproduction copy the directory ./node_modules/ogv/dist to ./public/ogv directory
ogv.OGVLoader.base = '/ogv';

export const useAudio = () => {
    const playAudio = useCallback((url: string) => {
        if (ogv.OGVCompat.supported('OGVPlayer')) {
            const player = new ogv.OGVPlayer();
            player.src = url;
            player.play();
        } else {
            const audio = new Audio(url);
            audio.play();
        }
    }, []);

    return { playAudio };
};
